import { Validator } from '../../types/Validator';

const errorCode = 'REQUIRED_WITH_FALSIES';

const requiredWithFalsies: Validator = value => {
  if (value === undefined || value === null) {
    return {
      errorCode
    };
  }
};

export { requiredWithFalsies, errorCode };
